<template>
  <div id="app">
    <!-- <router-view/> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {

    let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    let app = document.getElementById('app')
    app.style.height = h + 'px'
    document.body.style.minHeight = h + 'px'
    document.body.style.overflowY = 'auto'
  }
}

</script>
<style>
  /* html {
    overflow: hidden;
    height: 100%;
  } */
</style>



// WEBPACK FOOTER //
// src/App.vue